module.exports = __webpack_public_path__ + "img/bg2.cb473fee.png";